module.exports = __webpack_public_path__ + "472e55198f8a02d1b8df407a4ae22c0f.MP3";